import * as React from 'react';
import { graphql } from 'gatsby';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import PageWrapper from '../components/Common/PageWrapper/PageWrapper';
import PageTitleSection from '../components/Sections/Common/PageTitleSection/PageTitleSection';
import HeroSection from '../components/Sections/GetInTouch/HeroSection/HeroSection';
import FormSection from '../components/Sections/GetInTouch/FormSection/FormSection';
import MapSection from '../components/Sections/GetInTouch/MapSection/MapSection';
import { PagesList } from '../enums/PagesList';
import { Application } from '../interfaces/professional/Professional';
import { distanceConverter } from '../utils/distanceConverter';
import { TemplatesList } from '../enums/TemplatesList';

const Hello = ({ data, location: windowLocation }: Application) => {
  const { t } = useTranslation();
  const { longName, openingTime, businessInfo, externalLinks, location, locations, mobility, id, template } = data.professional.data;

  return (
    <PageWrapper
        windowLocation={windowLocation}
      template={template.template as TemplatesList}
      currentPage={t('header.menu.getInTouch.label')}
      color={template.color}
      pageId={PagesList.GET_IN_TOUCH}
      metaDescription={t('SEO.getInTouch.description')}
      metaTitle={t('SEO.getInTouch.title', { longName })}
    >
      <PageTitleSection template={template.template as TemplatesList}>{t('getInTouch.h1Title')}</PageTitleSection>
      <HeroSection
        template={template.template as TemplatesList}
        openingTime={openingTime}
        phone={businessInfo.phone}
        email={businessInfo.email}
        externalLinks={externalLinks}
        professionalID={id}
      />
      <FormSection template={template.template as TemplatesList} professionalID={id} />
      <MapSection
        phoneNumber={businessInfo.phone}
        primaryLocation={location}
        otherLocations={locations}
        mobilityRadius={mobility && distanceConverter(mobility.radius, mobility.unit === 'km')}
        template={template.template as TemplatesList}
      />
    </PageWrapper>
  );
};

export default Hello;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    professional {
      data {
        template {
          template
          color
        }
        id
        longName
        mobility {
          unit
          radius
        }
        location {
          placeDescription
          placeId
          name
          longitude
          latitude
        }
        locations {
          placeDescription
          placeId
          name
          longitude
          latitude
        }
        externalLinks {
          linkDescription
          url
        }
        businessInfo {
          email
          phone
          euVatNumber
          officialId
          paymentMethod
        }
        openingTime {
          monday {
            open
            closed
            availability
          }
          tuesday {
            open
            closed
            availability
          }
          wednesday {
            open
            closed
            availability
          }
          thursday {
            open
            closed
            availability
          }
          friday {
            open
            closed
            availability
          }
          saturday {
            open
            closed
            availability
          }
          sunday {
            open
            closed
            availability
          }
        }
      }
    }
  }
`;
